module.exports = __webpack_public_path__ + "static/media/3.3837b9ae.jpg";